import { HttpError } from 'serviceWorker/helpers/httpError';

export function isNotFoundOrForbidden(error: unknown): boolean {
  if (error instanceof HttpError) {
    return error.status === 404 || error.status === 403;
  }

  if (error instanceof Error) {
    const msg = error.message || '';
    return (
      msg.includes('Cannot find') ||
      msg.includes('Cannot access') ||
      msg.includes('Not Found') ||
      msg.includes('Forbidden')
    );
  }

  return false;
}

export function hasStatus(error: unknown, status: number): boolean {
  return error instanceof HttpError && error.status === status;
}
